/* global System */

export default { LineAwesomeIcon: () => System.import('./index') }
